<template>
<section>
  <div class="modal premium-modal" :class="{ 'is-active': visible }" id="modal">
    <div class="modal-background premium-modal__backdrop" @click="cancelModal()"></div>
    <div class="modal-card premium-modal__card">
      <header class="modal-card-head premium-modal__head">
        <div class="premium-modal__heading">
          <p class="premium-modal__eyebrow">{{ formName === 'companyForm' ? 'Directorio corporativo' : 'Operación' }}</p>
          <p class="modal-card-title premium-modal__title">{{ title }}</p>
        </div>
        <button class="delete premium-modal__close" @click.prevent="cancelModal()" aria-label="close"></button>
      </header>
      <section class="modal-card-body premium-modal__body" v-if="formName === 'billingForm'">
        <billingForm @billing-form-func="returnObject" />
      </section>
      <section class="modal-card-body premium-modal__body" v-if="formName === 'companyForm'">
        <companyForm @company-form-func="returnObject" :error="error" :strError="strError" />
      </section>
      <footer class="modal-card-foot premium-modal__foot">
        <button
          class="button premium-modal__action premium-modal__action--primary"
          :disabled="isProcessing"
          @click.prevent="saveObject()"
        >
          {{ isProcessing ? 'Guardando...' : (saveLabel ? saveLabel : 'Agregar') }}
        </button>
        <button
          class="button premium-modal__action premium-modal__action--secondary"
          :disabled="isProcessing"
          @click.prevent="cancelModal()"
        >
          Cancelar
        </button>
      </footer>
    </div>
  </div>
</section>
</template>

<script>
import billingForm from '../components/billing/billingForm.vue'
import companyForm from '@/components/company/CompanyForm.vue'

export default {
  name: 'ModalForm',
  components: {
    billingForm,
    companyForm
  },
  data: () => ({
    resultObject: {},
    convertCurrencies: [],
    isProcessing: false
  }),
  props: {
    title: String,
    visible: Boolean,
    formName: String,
    saveLabel: String,
    error: Boolean,
    strError: String
  },
  methods: {
    cancelModal () {
      this.isProcessing = false
      this.$emit('close-modal-func')
    },
    returnObject (objectModified, valor_uf) {
      this.resultObject = objectModified
      this.convertCurrencies = [{ currency_id: 2, value_CLP: valor_uf }]
    },
    saveObject () {
      this.isProcessing = true
      this.$emit('save', this.resultObject, this.convertCurrencies)
    }
  },
  watch: {
    error: function (newVal) {
      if (newVal) {
        this.isProcessing = false
      }
    }
  }
}
</script>

<style scoped>
.premium-modal {
  z-index: 700;
  padding: 1rem;
}

.premium-modal__backdrop {
  background: rgba(22, 18, 14, 0.58);
  backdrop-filter: blur(8px);
}

.premium-modal__card {
  width: min(720px, calc(100vw - 2rem));
  max-height: none;
  border: 1px solid rgba(255, 255, 255, 0.48);
  border-radius: 30px;
  overflow: hidden;
  background:
    radial-gradient(circle at top right, rgba(234, 220, 202, 0.55), transparent 32%),
    linear-gradient(180deg, rgba(255, 252, 247, 0.98), rgba(248, 242, 234, 0.95));
  box-shadow: 0 34px 90px rgba(33, 24, 16, 0.24);
}

.premium-modal__head,
.premium-modal__body,
.premium-modal__foot {
  border: 0;
  background: transparent;
}

.premium-modal__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.7rem 1.7rem 1.15rem;
}

.premium-modal__heading {
  min-width: 0;
}

.premium-modal__eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgba(68, 55, 41, 0.55);
}

.premium-modal__title {
  margin: 0;
  color: #201a14;
  font-size: clamp(1.9rem, 3vw, 2.35rem);
  font-weight: 650;
  letter-spacing: -0.04em;
  line-height: 1;
}

.premium-modal__close {
  flex-shrink: 0;
  margin-left: auto;
  width: 2rem;
  height: 2rem;
  background: rgba(255, 255, 255, 0.54);
  border: 1px solid rgba(88, 71, 53, 0.08);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.9),
    0 8px 20px rgba(56, 42, 28, 0.08);
  transition: background 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}

.premium-modal__close:hover,
.premium-modal__close:focus {
  background: rgba(255, 255, 255, 0.78);
  transform: translateY(-1px);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.94),
    0 12px 24px rgba(56, 42, 28, 0.12);
}

.premium-modal__body {
  padding: 0.35rem 1.7rem 0;
  overflow: visible;
}

.premium-modal__foot {
  display: flex;
  justify-content: flex-start;
  gap: 0.75rem;
  padding: 1.35rem 1.7rem 1.7rem;
}

.premium-modal__action {
  height: 3rem;
  padding: 0 1.15rem;
  border-radius: 999px;
  font-weight: 600;
  box-shadow: none;
}

.premium-modal__action--primary {
  border: 0;
  background: linear-gradient(135deg, #201a14, #4c3b2b);
  color: #fff7ef;
  box-shadow: 0 14px 30px rgba(42, 30, 18, 0.18);
}

.premium-modal__action--primary:hover,
.premium-modal__action--primary:focus {
  color: #fff7ef;
}

.premium-modal__action--secondary {
  min-width: 7.35rem;
  border: 1px solid rgba(69, 55, 40, 0.14);
  background: rgba(255, 255, 255, 0.86);
  color: #4a3a2c;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.96),
    0 8px 18px rgba(66, 48, 29, 0.05);
}

.premium-modal__action--secondary:hover,
.premium-modal__action--secondary:focus {
  border-color: rgba(69, 55, 40, 0.22);
  background: rgba(255, 255, 255, 0.96);
  color: #2f2419;
}

@media (max-width: 640px) {
  .premium-modal {
    padding: 0.75rem;
  }

  .premium-modal__card {
    width: calc(100vw - 1.5rem);
    border-radius: 24px;
  }

  .premium-modal__head,
  .premium-modal__body,
  .premium-modal__foot {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .premium-modal__title {
    font-size: 1.6rem;
  }

  .premium-modal__foot {
    flex-direction: column;
  }

  .premium-modal__action {
    width: 100%;
  }
}
</style>



